'use client'

import { useEffect, useState } from 'react'
import useUserOrderedStore from '@/store/userOrderedStore'
import { toast } from '@/hooks/use-toast'
import EditProfile from '../common/EditProfile'
import useCommonStore from '@/store/commonStore'
import { GTMUserProfile } from '@/lib/analytics'
export default function ProfileData() {
  const [editMode, setEditMode] = useState(false)
  const [loading, setLoading] = useState(false)
  const { translations } = useCommonStore()
  const { fetchUserProfile, userDetails } = useUserOrderedStore()

  useEffect(() => {
    fetchProfile()
  }, [])
  const fetchProfile = async () => {
    setLoading(true)
    const result = await fetchUserProfile()
    GTMUserProfile(result.data?.uid)
    setLoading(false)
    if (!result?.data) {
      toast({
        title: "Error",
        description: result?.error || result.message,
        variant: "destructive"
      })
    }
  }
  if (editMode) {
    return <EditProfile translations={translations} onClose={() => setEditMode(false)} />
  }

  return (
    <>
      <h1 className="text-7xl font-bold text-chart-3 mb-8 hidden md:block">{translations["profile"] || "Profile"}</h1>
      <div className="max-w-xl border rounded-lg md:border-none p-4 md:p-0">
        <div className="space-y-4 md:space-y-6 flex flex-col">
          <div className="flex gap-4">
            <div className="text-sm md:text-base">{translations["frst_nm"] || "First name"}:</div>
            <div className="font-bold">{userDetails?.fname || "-"}</div>
          </div>
          <div className="flex gap-4">
            <div className="text-sm md:text-base">{translations["lst_nm"] || "Last name"}:</div>
            <div className="font-medium">{userDetails?.lname || "-"}</div>
          </div>

          <div className='flex gap-4'>
            <div className="text-sm md:text-base">{translations["mbl_nm"] || "Mobile number"}:</div>
            <div className="font-medium">{userDetails?.phn_cd || "-"} {userDetails?.phn_num || "-"}</div>
          </div>

          <div className='flex gap-4'>
            <div className="text-sm md:text-base">{translations["email"] || "Email ID"}:</div>
            <div className="font-medium">{userDetails?.email || "-"}</div>
          </div>

          <div className="flex gap-4">
            <div className="text-sm md:text-base">{translations["gndr"] || "Gender"}:</div>
            <div className="font-medium capitalize">{userDetails?.gnd || "-"}</div>
          </div>
          {/* <div className="flex gap-4">
              <div className="text-sm md:text-base">{translations["dob"]||'Date of birth'}:</div>
              <div className="font-medium">{userDetails?.dob || "-"}</div>
            </div> */}

          {/* <div className='flex gap-4'>
            <div className="text-sm md:text-base">Location:</div>
            <div className="font-medium">{userDetails?.locality || "-"}</div>
          </div> */}

          <div className='flex gap-4'>
            <div className="text-sm md:text-base">{translations["alt_num"] || "Alternate Mobile"}:</div>
            <div className="font-medium">{userDetails?.alt_phn_num || "-"}</div>
          </div>

          <button
            className="bg-primary text-white px-6 py-2 w-fit rounded font-bold"
            onClick={() => setEditMode(true)}
          >
            {translations["edt_updt_prfl"] || "Edit/Update details"}
          </button>
        </div>
      </div>
    </>
  )
}



// 'use client'

// import { toast } from '@/hooks/use-toast'
// import useCommonStore from '@/store/commonStore'
// import useUserOrderedStore from '@/store/userOrderedStore'
// import { useEffect, useState } from 'react'


// interface IObj {
//     [key: string]: any
// }
// export default function ProfileData() {
//   const [editMode, setEditMode] = useState(false)
//   const [loading, setLoading] = useState(false)
//   const [details, setDetails] = useState<IObj>({})

//   const {fetchUserProfile, userDetails} = useUserOrderedStore()

//   useEffect(() => {
//     fetchProfile()
//   }, [])
//   const fetchProfile = async () => {
//     setLoading(true)
//     const result = await fetchUserProfile()
//     setLoading(false)
//     if(! result?.data){
//       toast({
//         title: "Error",
//         description: result?.error || result.message,
//         variant: "destructive"
//       })
//     }
//   }

//   return (
//     <>
//       <h1 className="text-7xl font-bold text-chart-3 mb-8">Profile</h1>
//       <div className="max-w-xl bg-white rounded-xl p-6 shadow">
//         {!editMode ? (
//           <div className="space-y-3">
//             <div className="flex gap-4">
//               <div className="flex-1">
//                 <div className="text-sm md:text-base">First name</div>
//                 <div className="font-medium">{userDetails?.fname || "-"}</div>
//               </div>
//               <div className="flex-1">
//                 <div className="text-sm md:text-base">Last name</div>
//                 <div className="font-medium">{userDetails?.lname || "-"}</div>
//               </div>
//             </div>
//             <div>
//               <div className="text-sm md:text-base">Mobile number</div>
//               <div className="font-medium">{userDetails?.phn_num}</div>
//             </div>
//             <div>
//               <div className="text-sm md:text-base">Email ID</div>
//               <div className="font-medium">{userDetails?.email || "-"}</div>
//             </div>
//             <div className="flex gap-4">
//               <div className="flex-1">
//                 <div className="text-sm md:text-base">Gender</div>
//                 <div className="font-medium capitalize">{userDetails?.gnd || "-"}</div>
//               </div>
//               <div className="flex-1">
//                 <div className="text-sm md:text-base">Date of birth</div>
//                 <div className="font-medium">{userDetails?.dob || "-"}</div>
//               </div>
//             </div>
//             <div>
//               <div className="text-sm md:text-base">Location</div>
//               <div className="font-medium">{userDetails?.locality || "-"}</div>
//             </div>
//             <div>
//               <div className="text-sm md:text-base">Alternate Mobile</div>
//               <div className="font-medium">{userDetails?.alt_phn_num || "-"}</div>
//             </div>
//             <button
//               className="bg-primary text-white px-6 py-2 rounded font-semibold mt-2"
//               onClick={() => setEditMode(true)}
//             >
//               Edit Profile
//             </button>
//           </div>
//         ) : (
//           <form
//             className="space-y-4"
//             onSubmit={e => {
//               e.preventDefault()
//               setEditMode(false)
//             }}
//           >
//             <div className="flex gap-4">
//               <div className="flex-1">
//                 <label htmlFor="firstName" className="block text-sm mb-1">First name</label>
//                 <input id="firstName" className="w-full border rounded px-3 py-2" value={details?.fname} onChange={e => setDetails(f => ({ ...f, fname: e.target.value }))} />
//               </div>
//               <div className="flex-1">
//                 <label htmlFor="lastName" className="block text-sm mb-1">Last name</label>
//                 <input id="lastName" className="w-full border rounded px-3 py-2" value={details?.lname} onChange={e => setDetails(f => ({ ...f, lname: e.target.value }))} />
//               </div>
//             </div>
//             <div>
//               <label htmlFor="mobile" className="block text-sm mb-1">Mobile number</label>
//               <input id="mobile" className="w-full border rounded px-3 py-2" value={details?.phn_num} onChange={e => setDetails(f => ({ ...f, phn_num: e.target.value }))} />
//             </div>
//             <div>
//               <label htmlFor="email" className="block text-sm mb-1">Email ID</label>
//               <input id="email" className="w-full border rounded px-3 py-2" value={details?.email} onChange={e => setDetails(f => ({ ...f, email: e.target.value }))} />
//             </div>
//             <div className="flex gap-4">
//               <div className="flex-1">
//                 <label htmlFor="gender" className="block text-sm mb-1">Gender</label>
//                 <select id="gender" className="w-full border rounded px-3 py-2" value={details?.gnd} onChange={e => setDetails(f => ({ ...f, gnd: e.target.value }))}>
//                   <option value="">Select</option>
//                   <option value="male">Male</option>
//                   <option value="female">Female</option>
//                   <option value="other">Other</option>
//                 </select>
//               </div>
//               <div className="flex-1">
//                 <label htmlFor="dob" className="block text-sm mb-1">Date of birth</label>
//                 <input
//                   id="dob"
//                   type="date"
//                   className="w-full border rounded px-3 py-2"
//                   value={details?.dob}
//                   onChange={e => setDetails(f => ({ ...f, dob: e.target.value }))}
//                 />
//               </div>
//             </div>
//             <div>
//               <label htmlFor="location" className="block text-sm mb-1">Location</label>
//               <input id="location" className="w-full border rounded px-3 py-2" value={details?.locality} onChange={e => setDetails(f => ({ ...f, locality: e.target.value }))} />
//             </div>
//             <div>
//               <label htmlFor="altMobile" className="block text-sm mb-1">Alternate Mobile</label>
//               <input id="altMobile" className="w-full border rounded px-3 py-2" value={details?.alt_phn_num} onChange={e => setDetails(f => ({ ...f, alt_phn_num: e.target.value }))} />
//             </div>
//             <div className="flex gap-3">
//               <button type="submit" className="bg-primary text-white px-6 py-2 rounded font-semibold mt-2">
//                 Update Profile
//               </button>
//               <button
//                 type="button"
//                 className="bg-gray-200 text-gray-700 px-6 py-2 rounded font-semibold mt-2"
//                 onClick={() => setEditMode(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         )}
//       </div>
//     </>
//   )
// }